module.exports = __webpack_public_path__ + "static/media/twitter.a57ea219.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/_minha-central/Footer/social-icons/twitter.svg
// module id = 1438
// module chunks = 0